<template>
  <div class="row">
    <div id="tren-group" class="col-md-12 px-gap">
      <div class="card card-default shade mb-4">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="pull-left m-t-5 m-b-5">
                <h4 class="m-b-0">Grafik Tren Grup Topik</h4>
                <p class="small hint-text">Grafik Tren Grup Topik</p>
              </div>
              <div class="pull-right mt-3">
                <button class="btn btn-success mr-3" @click="getDataExcel">
                  <i class="bi bi-filetype-xlsx mr-1"></i> Ekspor Data
                </button>
                <div class="form-check form-check-inline switch">
                  <input
                    type="checkbox"
                    id="show-bar-group"
                    v-model="show_bar"
                  />
                  <label for="show-bar-group">Tampilkan Grafik Bar</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <loader-component v-if="is_loading" style="margin: auto" />
              <div v-else>
                <div
                  v-if="!data"
                  class="alert alert-danger"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div v-else>
                  <div v-if="!show_bar">
                    <dynamic-chart-component
                      :config="config"
                      chart_id="garfik-grup"
                    />
                  </div>
                  <div v-else>
                    <bar-chart-component :data="bar_chart_data" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dynamic_chart from "@/views/components/chart/dynamic_chart.vue";
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import loader_component from "@/views/components/loader.vue";
import XLSX from "xlsx";

export default {
  name: "grafikGrup",
  props: {
    is_loading: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    data: {
      type: Object,
      default: function() {
        return null;
      },
    },
  },
  components: {
    "dynamic-chart-component": dynamic_chart,
    "bar-chart-component": bar_chart_horizontal,
    "loader-component": loader_component,
  },
  data() {
    return {
      config: null,
      show_bar: false,
      excel_fields: {
        "Nama Group": "Nama Group",
        Tanggal: "Tanggal",
        jumlah: "Jumlah Topik",
      },
      excel_data: [],
      bar_chart_data: {},
    };
  },
  methods: {
    getDataExcel: function() {
      for (let tanggal in this.data.date) {
        for (let row in this.data) {
          if (row != "date") {
            this.excel_data.push({
              "Nama Grup": row,
              Tanggal: this.data.date[tanggal],
              "Jumlah Berita": this.data[row].main[tanggal],
            });
          }
        }
      }
      this.$store.dispatch("loading", true);
      var topik = XLSX.utils.json_to_sheet(this.excel_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, topik, "Topik");
      XLSX.writeFile(wb, "Topik.xlsx");
      this.$store.dispatch("loading", false);
    },
    getRandColor: function(same, darkness) {
      var rgb = [];
      let lastColor;
      if (same && lastColor) {
        rgb = lastColor;
      } else {
        rgb = [Math.random() * 256, Math.random() * 256, Math.random() * 256];
      }
      var mix = [darkness * 51, darkness * 51, darkness * 51];
      var mixedrgb = [rgb[0] + mix[0], rgb[1] + mix[1], rgb[2] + mix[2]].map(
        function(x) {
          return Math.round(x / 2.0);
        }
      );
      lastColor = rgb;
      return "rgb(" + mixedrgb.join(",") + ")";
    },
    assembleChart: function() {
      if (this.data) {
        let series = [];
        let drilldown = [];
        for (let row in this.data) {
          if (row != "date") {
            let main_data = [];
            for (let main_row in this.data[row].main) {
              main_data.push({
                name: this.data.date[main_row],
                y: this.data[row].main[main_row],
                drilldownName: row,
                drilldown: true,
              });
            }
            series.push({
              name: row,
              data: main_data,
            });

            drilldown[row] = [];
            for (let child_row in this.data[row].child) {
              drilldown[row].push({
                name: child_row,
                color: this.getRandColor(true, 5),
                data: this.data[row].child[child_row],
              });
            }
          }
        }
        this.bar_chart_data.x = this.data.date;
        this.bar_chart_data.y = series;

        this.config = {
          chart: {
            type: "spline",
            backgroundColor: "transparent",
            events: {
              drilldown: function(e) {
                if (!e.seriesOptions) {
                  var chart = this,
                    drilldowns = drilldown,
                    series = drilldowns[e.point.drilldownName];
                  if (series.length > 0) {
                    for (let series_row in series) {
                      chart.addSingleSeriesAsDrilldown(
                        e.point,
                        series[series_row]
                      );
                    }
                    chart.applyDrilldown();
                  }
                }
              },
            },
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "",
          },
          legend: {
            enabled: true,
            maxHeight: 100,
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
              },
            },
          },
          xAxis: [
            {
              categories: this.data.date,
              crosshair: true,
            },
          ],
          yAxis: [
            {
              title: {
                text: "Posting",
              },
            },
          ],
          exporting: {
            enabled: true,
            allowHTML: true,
          },
          series: series,
          drilldown: {
            series: [],
          },
        };
      }
    },
  },
  mounted: function() {
    this.assembleChart();
  },
  watch: {
    data() {
      this.assembleChart();
    },
  },
};
</script>
